import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const BOOKING_URL = "https://beautesolutions.intakeq.com/booking";

export default function CTASection({ title = "Begin with a consultation" }) {
  return (
    <section className="bg-espresso text-cream py-14 lg:py-20" data-testid="cta-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <Reveal>
          <p className="font-serif italic text-xl sm:text-2xl text-gold mb-4">Free consultation</p>
          <h2 className="font-serif text-3xl sm:text-5xl leading-tight">{title}</h2>
          <p className="mt-4 text-cream/60 max-w-xl mx-auto leading-relaxed">
            Booking is our only point of contact, so every enquiry gets a proper
            consultation — honest guidance, never hype.
          </p>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-booking-btn"
            className="group mt-8 inline-flex items-center gap-2.5 rounded-full bg-gold text-espresso px-10 py-5 text-base font-semibold transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-cream"
          >
            Free photo consultation
            <ArrowRight size={17} className="transition-transform duration-300 group-hover:translate-x-1" />
          </a>
          <p className="mt-5">
            <a
              href="https://beautesolutions.intakeq.com/portal"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-portal-link"
              className="font-semibold text-gold underline decoration-gold/40 underline-offset-4 transition-colors duration-300 hover:text-cream"
            >
              Already booked? Open your consult portal
            </a>
          </p>
        </Reveal>
      </div>
    </section>
  );
}
